export default __webpack_public_path__ + "static/media/books-480w.c35c7360.webp";